import { ThemeInterface } from '@westwing/ui-kit/Theme';
import styled, { ThemeProps } from 'styled-components';
import { fromBreakpoint, TABLET } from '../../../../mediaqueries';

interface OverlayHeaderProps extends ThemeProps<ThemeInterface> {
    isVisible: boolean;
}
export const OverlayHeader = styled.div<OverlayHeaderProps>`
    align-items: center;
    display: ${(props: OverlayHeaderProps) => (props.isVisible ? 'flex' : 'none')};
    justify-content: flex-end;
    height: 48px;
    overflow: hidden;

    ${fromBreakpoint[TABLET]`
        display: flex;
    `}
`;
